import DocumentUploadPage from "./DocumentUploadPage";

export default DocumentUploadPage;
